import { useNavigate } from "react-router-dom";
import "./Category.scss";
import { colors } from "@mui/material";

const Category = ({ categories }) => {
  const navigate = useNavigate();
  return (
    <div className="shop-by-category  py-2 ">
      <h1
        style={{
          marginTop: "30px",
          marginBottom: "30px",
          textAlign: "center",
          zIndex: "10",
        }}
        className="  relative z-50 py-2"
      >
        <h1 className=" absolute inset-0 flex items-center justify-center  -top-8 text-[3rem] md:text-[5rem]  font-thin z-0 text-[#E8E8E8]  ">
          PRODUCT
        </h1>
        <h1 className=" absolute inset-0 flex items-center justify-center    top-3 text-[1.3rem] md:text-[2.1rem] font-bold z-0 text-[#C51414] ">
          SHOP BY CATEGORY
        </h1>
        .
      </h1>
      <div className="  grid   grid-cols-3 md:grid-cols-9   lg:grid-cols-9 gap-5 gap-y-6">
        {categories?.map((item) => (
          <div
            key={item.id}
            className="category"
            onClick={() => navigate(`/category/${item.link}`)}
          >
            <img src={item.images} />
            <div
              style={{ textAlign: "center" }}
              className=" mt-2 text-xs text-[#C51414] font-bold    tracking-[0.08rem]  "
            >
              {item.name}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Category;
